module.exports = __webpack_public_path__ + "static/img/four_10.ed291ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_10.png
// module id = Ohyh
// module chunks = 3